'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.injectDefaultListeners = injectDefaultListeners;
exports.removeDefaultListeners = removeDefaultListeners;

var _Injection = require('../../shared/VideoStore/Injection');

var _MediaEventConstants = require('../../shared/VideoStore/MediaEventConstants');

var _MediaEventConstants2 = _interopRequireDefault(_MediaEventConstants);

var _defaultAdBeganListener = require('./defaultAdBeganListener');

var _defaultAdBeganListener2 = _interopRequireDefault(_defaultAdBeganListener);

var _defaultAdEndedListener = require('./defaultAdEndedListener');

var _defaultAdEndedListener2 = _interopRequireDefault(_defaultAdEndedListener);

var _defaultCanPlayListener = require('./defaultCanPlayListener');

var _defaultCanPlayListener2 = _interopRequireDefault(_defaultCanPlayListener);

var _defaultEndedListener = require('./defaultEndedListener');

var _defaultEndedListener2 = _interopRequireDefault(_defaultEndedListener);

var _defaultLoadedMetadataListener = require('./defaultLoadedMetadataListener');

var _defaultLoadedMetadataListener2 = _interopRequireDefault(_defaultLoadedMetadataListener);

var _defaultAddTrackListener = require('./defaultAddTrackListener');

var _defaultAddTrackListener2 = _interopRequireDefault(_defaultAddTrackListener);

var _defaultPauseListener = require('./defaultPauseListener');

var _defaultPauseListener2 = _interopRequireDefault(_defaultPauseListener);

var _defaultPlayListener = require('./defaultPlayListener');

var _defaultPlayListener2 = _interopRequireDefault(_defaultPlayListener);

var _defaultPlaylistItemListener = require('./defaultPlaylistItemListener');

var _defaultPlaylistItemListener2 = _interopRequireDefault(_defaultPlaylistItemListener);

var _defaultQualityChangedListener = require('./defaultQualityChangedListener');

var _defaultQualityChangedListener2 = _interopRequireDefault(_defaultQualityChangedListener);

var _defaultVolumeChangeListener = require('./defaultVolumeChangeListener');

var _defaultVolumeChangeListener2 = _interopRequireDefault(_defaultVolumeChangeListener);

var _defaultDurationMsChangeListener = require('./defaultDurationMsChangeListener');

var _defaultDurationMsChangeListener2 = _interopRequireDefault(_defaultDurationMsChangeListener);

var _defaultExpectedDurationMsChangeListener = require('./defaultExpectedDurationMsChangeListener');

var _defaultExpectedDurationMsChangeListener2 = _interopRequireDefault(_defaultExpectedDurationMsChangeListener);

var _defaultErrorListener = require('./defaultErrorListener');

var _defaultErrorListener2 = _interopRequireDefault(_defaultErrorListener);

var _loopListener = require('./loopListener');

var _loopListener2 = _interopRequireDefault(_loopListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function injectDefaultListeners(playerId) {
  (0, _Injection.injectEventListener)(_MediaEventConstants2.default.adBegan, _defaultAdBeganListener2.default, playerId);
  (0, _Injection.injectEventListener)(_MediaEventConstants2.default.adEnded, _defaultAdEndedListener2.default, playerId);
  (0, _Injection.injectEventListener)(_MediaEventConstants2.default.canPlay, _defaultCanPlayListener2.default, playerId);
  (0, _Injection.injectEventListener)(_MediaEventConstants2.default.ended, _defaultEndedListener2.default, playerId);
  (0, _Injection.injectEventListener)(_MediaEventConstants2.default.loadedMetadata, _defaultLoadedMetadataListener2.default, playerId);
  (0, _Injection.injectEventListener)(_MediaEventConstants2.default.addTrack, _defaultAddTrackListener2.default, playerId);
  (0, _Injection.injectEventListener)(_MediaEventConstants2.default.pause, _defaultPauseListener2.default, playerId);
  (0, _Injection.injectEventListener)(_MediaEventConstants2.default.play, _defaultPlayListener2.default, playerId);
  (0, _Injection.injectEventListener)(_MediaEventConstants2.default.playlistItem, _defaultPlaylistItemListener2.default, playerId);
  (0, _Injection.injectEventListener)(_MediaEventConstants2.default.qualityChanged, _defaultQualityChangedListener2.default, playerId);
  (0, _Injection.injectEventListener)(_MediaEventConstants2.default.volumeChange, _defaultVolumeChangeListener2.default, playerId);
  (0, _Injection.injectEventListener)(_MediaEventConstants2.default.timeUpdate, _loopListener2.default, playerId);
  (0, _Injection.injectEventListener)(_MediaEventConstants2.default.durationMsChange, _defaultDurationMsChangeListener2.default, playerId);
  (0, _Injection.injectEventListener)(_MediaEventConstants2.default.expectedDurationMsChange, _defaultExpectedDurationMsChangeListener2.default, playerId);
  (0, _Injection.injectEventListener)(_MediaEventConstants2.default.error, _defaultErrorListener2.default, playerId);
}

// special


// defaults
/*
 * Copyright 2016 hudl
 * All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @providesModule injectDefaultListener
 * 
 */

function removeDefaultListeners(playerId) {
  (0, _Injection.removeEventListener)(_MediaEventConstants2.default.adBegan, _defaultAdBeganListener2.default, playerId);
  (0, _Injection.removeEventListener)(_MediaEventConstants2.default.adEnded, _defaultAdEndedListener2.default, playerId);
  (0, _Injection.removeEventListener)(_MediaEventConstants2.default.canPlay, _defaultCanPlayListener2.default, playerId);
  (0, _Injection.removeEventListener)(_MediaEventConstants2.default.ended, _defaultEndedListener2.default, playerId);
  (0, _Injection.removeEventListener)(_MediaEventConstants2.default.loadedMetadata, _defaultLoadedMetadataListener2.default, playerId);
  (0, _Injection.removeEventListener)(_MediaEventConstants2.default.addTrack, _defaultAddTrackListener2.default, playerId);
  (0, _Injection.removeEventListener)(_MediaEventConstants2.default.pause, _defaultPauseListener2.default, playerId);
  (0, _Injection.removeEventListener)(_MediaEventConstants2.default.play, _defaultPlayListener2.default, playerId);
  (0, _Injection.removeEventListener)(_MediaEventConstants2.default.playlistItem, _defaultPlaylistItemListener2.default, playerId);
  (0, _Injection.removeEventListener)(_MediaEventConstants2.default.qualityChanged, _defaultQualityChangedListener2.default, playerId);
  (0, _Injection.removeEventListener)(_MediaEventConstants2.default.volumeChange, _defaultVolumeChangeListener2.default, playerId);
  (0, _Injection.removeEventListener)(_MediaEventConstants2.default.timeUpdate, _loopListener2.default, playerId);
  (0, _Injection.removeEventListener)(_MediaEventConstants2.default.durationMsChange, _defaultDurationMsChangeListener2.default, playerId);
  (0, _Injection.removeEventListener)(_MediaEventConstants2.default.expectedDurationMsChange, _defaultExpectedDurationMsChangeListener2.default, playerId);
  (0, _Injection.removeEventListener)(_MediaEventConstants2.default.error, _defaultErrorListener2.default, playerId);
}